module.exports = __webpack_public_path__ + "media/images/new_home/green-business-list-bg-c43aa9eb3d7ea959be7026617dcc5d59.svg";